<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

@if (
	authorizationService.canSee(grants.applicationsPercentageView) ||
	authorizationService.canSee(grants.applicationsTrueValueView)
) {
	@let emissionsAnalysisByScopeBarChart = emissionsAnalysisByScopeBarChart$ | async;
	<div class="cloud-applications-chart">
		<div class="cloud-applications-actions">
			<globalictcc-chips
				[chips]="chips"
				(handleSelection)="onModeChange($event)"
			/>

			<div class="cloud-applications-toolbar">
				<globalictcc-dropdown
					label="Order by"
					[options]="orderByOptions"
					[formControl]="orderByControl"
					(handleSelectionChange)="onOrderByChange($event)"
				/>

				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							emissionsAnalysisByScopeChart.instance,
							'cloud_applications_by_scope'
						)
					"
				/>
			</div>
		</div>

		<globalictcc-chart
			#emissionsAnalysisByScopeChart
			chartType="barY"
			[isTitleVisible]="false"
			[isLegendVisible]="true"
			labelPosition="outside"
			[data]="emissionsAnalysisByScopeBarChart?.data?.chart"
			[hasError]="
				emissionsAnalysisByScopeBarChart?.hasError ||
				emissionsAnalysisByScopeBarChart?.data?.hasError
			"
			[isLoading]="emissionsAnalysisByScopeBarChart?.isLoading ?? true"
			[colors]="EmissionsAnalysisBarChartColors"
			[configOverrides]="emissionsAnalysisByScopeBarChartOverrides"
		/>
	</div>
}
